// Create — a thin wrapper around the shared ProjectForm. Kept as its
// own page so the existing route (/create) and test-ids stay stable.
// All wizard logic, field definitions, and validation live in
// components/ProjectForm.jsx — the same component powers Steward Tools
// (edit mode) under /project/:id/manage.

import ProjectForm from "../components/ProjectForm";

export default function Create() {
  return <ProjectForm mode="create" />;
}
